import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';

class ResultService {
  //* For debugging
  public toString(state: ApiPortfolioState) {
    switch (state) {
      case ApiPortfolioState.AssessmentBase:
        return 'AssessmentBase';
      case ApiPortfolioState.AssessmentLock:
        return 'AssessmentLock';
      case ApiPortfolioState.AssessmentMark:
        return 'AssessmentMark';
      case ApiPortfolioState.AssessmentRetry:
        return 'AssessementRetry';
      case ApiPortfolioState.AssessmentStart:
        return 'AssessmentStart';
      case ApiPortfolioState.AssessmentSubmit:
        return 'AssessmentSubmit';
      case ApiPortfolioState.LessonBase:
        return 'LessonBase';
      case ApiPortfolioState.LessonStart:
        return 'LessonStart';
      case ApiPortfolioState.QuizBase:
        return 'QuizBase';
      case ApiPortfolioState.QuizLock:
        return 'QuizLock';
      case ApiPortfolioState.QuizStart:
        return 'QuizStart';
      default:
        return 'Unknown';
    }
  }
}

export default new ResultService();
